import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=2895bd44&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"
import style0 from "./Album.vue?vue&type=style&index=0&id=2895bd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895bd44",
  null
  
)

export default component.exports